<div class="main d-flex">
    <app-side-view></app-side-view>
    <app-map-view></app-map-view>
</div>